import { FC } from 'react';
import { Container } from 'react-bootstrap';
import { Button } from '../../atoms';
import { useNavigate, useParams } from 'react-router-dom';
import cn from 'classnames';
import styles from './LandscapeProjectsAddProjectsGeneralInformationLeadPartnersTemplate.module.css';
import BaseTemplate from '../BaseTemplate';
import LandscapeEditProjectsAddProjectTemplate from '../../../templates/LandscapeEditProjectsAddProjectTemplate';
import LandscapeProjectsEditProjectsGeneralInformationTemplate from '../../../templates/LandscapeProjectsEditProjectsGeneralInformationTemplate';
import { LandscapeProjectsAddProjectsGeneralInformationLeadPartnersOrganism } from '../../organisms';
import { BuyerResponseDto } from '../../../store/buyerAPI/buyer/dto/response/buyer-response.dto';
import { ProjectOrganizationRelationType } from '../../../store/tradeAPI/projectSupporter/project-organization-relation-type';

interface LandscapeProjectsAddProjectsGeneralInformationLeadPartnersTemplateProps {
  data: BuyerResponseDto[];
  handleDelete: (id: string) => void;
}

const LandscapeProjectsAddProjectsGeneralInformationLeadPartnersTemplate: FC<
  LandscapeProjectsAddProjectsGeneralInformationLeadPartnersTemplateProps
> = ({ data, handleDelete }) => {
  const navigate = useNavigate();
  const { id, projectId } = useParams();
  return (
    <>
      <BaseTemplate>
        <Container>
          <LandscapeEditProjectsAddProjectTemplate>
            <LandscapeProjectsEditProjectsGeneralInformationTemplate>
              <div className={cn(styles.landscapeAboutContactPersonsWrapper)}>
                <div className={cn(styles.button)}>
                  <Button
                    variant="dark"
                    onClick={() =>
                      navigate(
                        `/landscapes/edit/${id}/projects/add-project/${projectId}/supporters/add-supporter/${ProjectOrganizationRelationType.Initiator}`
                      )
                    }
                  >
                    Add Supporter
                  </Button>
                </div>
                <div className={cn(styles.tableWrapper)}>
                  <LandscapeProjectsAddProjectsGeneralInformationLeadPartnersOrganism
                    data={data}
                    handleDelete={handleDelete}
                    relationType={ProjectOrganizationRelationType.Initiator}
                  />
                </div>
              </div>
            </LandscapeProjectsEditProjectsGeneralInformationTemplate>
          </LandscapeEditProjectsAddProjectTemplate>
        </Container>
      </BaseTemplate>
    </>
  );
};

export default LandscapeProjectsAddProjectsGeneralInformationLeadPartnersTemplate;
